/**
 * Auth server
 * Auth server API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum LivenessQrStatus {
    CREATED = 'CREATED',
    SCANNED = 'SCANNED',
    LIMIT_PER_SESSION_EXCEEDED = 'LIMIT_PER_SESSION_EXCEEDED',
    CAMERA_FAILED = 'CAMERA_FAILED',
    FACE_NOT_MATCHED = 'FACE_NOT_MATCHED',
    CANCELED = 'CANCELED',
    FINISHED = 'FINISHED',
    EXPIRED = 'EXPIRED'
}

